import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import ThemeProvider from "./utils/theme.jsx";
import {
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import App from "./App.jsx";
import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { AuthProvider } from "./contexts/AuthContext.jsx";
import { queryClient } from "./adapters/api.js";
import { msalInstance } from "./utils/MSAuthConfig.js";
import { Toaster } from "sonner";

// Create a default MUI theme and ensure alpha utility is available
const muiTheme = createTheme({
  // Explicitly ensure alpha is available by using it in theme creation
  // This prevents tree-shaking from removing it in production builds
});

// Ensure alpha is available on theme object for production builds
if (!muiTheme.alpha) {
  muiTheme.alpha = alpha;
}

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <AuthProvider>
          <MuiThemeProvider theme={muiTheme}>
            <ThemeProvider>
              <QueryClientProvider client={queryClient}>
                <Toaster
                  richColors
                  position="top-center"
                  duration={5000}
                  closeButton
                  toastOptions={{
                    style: {
                      fontSize: "16px",
                      padding: "12px 16px",
                      maxWidth: "calc(100vw - 24px)",
                      width: "fit-content",
                    },
                    className:
                      "text-sm sm:text-base font-medium shadow-lg mt-4",
                  }}
                />
                <App />
                {/* <ReactQueryDevtools /> */}
              </QueryClientProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </AuthProvider>
      </MsalProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
